var _rect, _rect2, _path, _text, _text2, _path2, _path3, _g, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg110(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uC0DD\uC77C\uBC88\uD638 \uD3B8\uC911") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#fff8e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 280,
    height: 270,
    rx: 24,
    fill: "#fff",
    stroke: "#e0a72b",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 145h280",
    stroke: "#e0a72b",
    strokeWidth: 8
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 225,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 58,
    fontWeight: 900,
    fill: "#172033"
  }, "1~31")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 285,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 28,
    fontWeight: 800,
    fill: "#7c4a03"
  }, "\uC0DD\uC77C\xB7\uAE30\uB150\uC77C")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M390 220h85",
    stroke: "#0f766e",
    strokeWidth: 9,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m452 193 33 27-33 27",
    fill: "none",
    stroke: "#0f766e",
    strokeWidth: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 31,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 155,
    r: 54,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 166
  }, "32"), /*#__PURE__*/React.createElement("circle", {
    cx: 665,
    cy: 155,
    r: 54,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 166
  }, "38"), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 285,
    r: 54,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 296
  }, "41"), /*#__PURE__*/React.createElement("circle", {
    cx: 665,
    cy: 285,
    r: 54,
    fill: "#ffd6db"
  }), /*#__PURE__*/React.createElement("text", {
    x: 665,
    y: 296
  }, "45"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 405,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 29,
    fontWeight: 900,
    fill: "#172033"
  }, "\uC758\uBBF8 \uC22B\uC790 + \uC790\uB3D9 \uC22B\uC790\uB85C \uBC94\uC704 \uB113\uD788\uAE30")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg110);
export default __webpack_public_path__ + "static/media/110-생일번호.01600d3af0c5f3cf8a6670fd254d8b10.svg";
export { ForwardRef as ReactComponent };